import Restraint from "./Restraint.js";
import Scenes from "oc-threejs/Scenes.js";
import {v3} from "oc-threejs/short3.js";
import AnchorAwareMixin from "./AnchorAwareMixin";

/**
 * Positioniert das Objekt in der Mitte einer Box
 */
class BoxCenterRestraint extends AnchorAwareMixin(Restraint) {

    /** @type {THREE.Box3} */
    box;
    /** @type {boolean} */
    freeOrientation;

    constructor(options) {
        super(options);
        this.box = options.box;
    }

    /**
     * @param {THREE.Ray} ray
     * @returns {?THREE.Vector3}
     */
    raycastLocal(ray) {
        let point = ray.intersectBox(this.box);
        if (!point) {
            return null;
        }
        return this.box.getCenter(point);
    }

    /**
     * @param {THREE.Raycaster} raycaster
     * @param {THREE.Vector3} point
     * @param {boolean} dropped
     */
    perform(raycaster, point, dropped) {
        Scenes.bring({
            what: [this.dragObject3d,this.anchorMatrix],
            to: [this.matrixWorld],
            rotate: !this.freeOrientation,
            translate: true,
        });
    }

    createDebugVisualization() {
        const parent = new THREE.Object3D();
        const box = Scenes.wireframe(Scenes.box(this.box.getSize()),1,STAGE.settings.dragDrop.restraintsDebugColor);
        box.position.copy(this.box.getCenter());
        parent.add(box);
        return parent;
    }

}

export default BoxCenterRestraint;
